import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/logo.svg'


const _hoisted_1 = { class: "o-nav" }
const _hoisted_2 = { class: "o-nav__logo" }
const _hoisted_3 = { class: "o-nav__list" }
const _hoisted_4 = {
  class: "c-nav",
  role: "navigation",
  "aria-label": "Main Navigation"
}
const _hoisted_5 = { class: "c-nav__list" }
const _hoisted_6 = { class: "c-nav__item" }
const _hoisted_7 = { class: "c-nav__icon" }
const _hoisted_8 = { class: "c-nav__item" }
const _hoisted_9 = { class: "c-nav__icon" }
const _hoisted_10 = {
  key: 0,
  class: "c-subnav"
}
const _hoisted_11 = { class: "c-subnav__item" }
const _hoisted_12 = { class: "c-subnav__item" }
const _hoisted_13 = { class: "c-nav__item" }
const _hoisted_14 = { class: "c-nav__icon" }
const _hoisted_15 = {
  key: 0,
  class: "c-subnav"
}
const _hoisted_16 = { class: "c-subnav__item" }
const _hoisted_17 = { class: "c-subnav__item" }
const _hoisted_18 = { class: "c-subnav__item" }
const _hoisted_19 = { class: "c-subnav__item" }
const _hoisted_20 = { class: "c-subnav__item" }
const _hoisted_21 = { class: "c-nav__item" }
const _hoisted_22 = { class: "c-nav__icon" }
const _hoisted_23 = {
  key: 0,
  class: "c-subnav"
}
const _hoisted_24 = { class: "c-subnav__item" }
const _hoisted_25 = { class: "c-subnav__item" }
const _hoisted_26 = { class: "c-subnav__item" }
const _hoisted_27 = { class: "c-subnav__item" }
const _hoisted_28 = { class: "c-subnav__item" }
const _hoisted_29 = { class: "c-nav__item" }
const _hoisted_30 = { class: "c-nav__icon" }
const _hoisted_31 = {
  key: 0,
  class: "c-subnav"
}
const _hoisted_32 = { class: "c-subnav__item" }
const _hoisted_33 = { class: "c-subnav__item" }
const _hoisted_34 = { class: "c-subnav__item" }
const _hoisted_35 = { class: "c-subnav__item" }
const _hoisted_36 = { class: "c-subnav__item" }
const _hoisted_37 = { class: "c-subnav__item" }
const _hoisted_38 = { class: "c-nav__item" }
const _hoisted_39 = { class: "c-nav__icon" }
const _hoisted_40 = {
  key: 0,
  class: "c-subnav"
}
const _hoisted_41 = { class: "c-subnav__item" }
const _hoisted_42 = { class: "c-subnav__item" }
const _hoisted_43 = { class: "c-subnav__item" }
const _hoisted_44 = { class: "c-subnav__item" }
const _hoisted_45 = { class: "c-subnav__item" }
const _hoisted_46 = { class: "c-nav__item" }
const _hoisted_47 = { class: "c-nav__icon" }
const _hoisted_48 = {
  key: 0,
  class: "c-subnav"
}
const _hoisted_49 = { class: "c-subnav__item" }
const _hoisted_50 = { class: "c-subnav__item" }
const _hoisted_51 = {
  class: "c-nav__item",
  style: {"visibility":"hidden","height":"0","min-height":"0"}
}
const _hoisted_52 = {
  key: 0,
  class: "c-subnav"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_icon_how_to_use = _resolveComponent("icon-how-to-use")!
  const _component_icon_design = _resolveComponent("icon-design")!
  const _component_transition_expand = _resolveComponent("transition-expand")!
  const _component_icon_layouts = _resolveComponent("icon-layouts")!
  const _component_icon_forms = _resolveComponent("icon-forms")!
  const _component_icon_components = _resolveComponent("icon-components")!
  const _component_icon_utilities = _resolveComponent("icon-utilities")!
  const _component_icon_devs = _resolveComponent("icon-devs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        class: "c-logo",
        to: "/"
      }, {
        default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
          _createElementVNode("img", {
            class: "c-logo__img",
            src: _imports_0,
            alt: "Design System logo"
          }, null, -1),
          _createElementVNode("span", { class: "c-logo__name" }, [
            _createTextVNode("Design System "),
            _createElementVNode("br"),
            _createTextVNode("Tutorial")
          ], -1)
        ]))]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("nav", _hoisted_4, [
        _createElementVNode("ul", _hoisted_5, [
          _createElementVNode("li", _hoisted_6, [
            _createVNode(_component_router_link, {
              to: { name: $data.HOW_TO_USE_ROUTE_NAME },
              class: "c-nav__link"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_icon_how_to_use)
                ]),
                _cache[8] || (_cache[8] = _createElementVNode("div", { class: "c-nav__name" }, "How to use", -1))
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _createElementVNode("li", _hoisted_8, [
            _createElementVNode("div", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($data.designIsOpen = !$data.designIsOpen)),
              class: _normalizeClass([{ 'is-open': $data.designIsOpen }, "c-nav__link has-subnav"])
            }, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_icon_design)
              ]),
              _cache[9] || (_cache[9] = _createElementVNode("div", { class: "c-nav__name" }, "Design", -1)),
              _cache[10] || (_cache[10] = _createElementVNode("span", { class: "c-nav__subnav-caret" }, null, -1))
            ], 2),
            _createVNode(_component_transition_expand, null, {
              default: _withCtx(() => [
                ($data.designIsOpen)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_10, [
                      _createElementVNode("li", _hoisted_11, [
                        _createVNode(_component_router_link, {
                          to: { name: $data.DESIGN_COLORS_ROUTE_NAME },
                          class: "c-subnav__link"
                        }, {
                          default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                            _createTextVNode(" Colors ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["to"])
                      ]),
                      _createElementVNode("li", _hoisted_12, [
                        _createVNode(_component_router_link, {
                          to: { name: $data.DESIGN_TYPOGRAPHY_ROUTE_NAME },
                          class: "c-subnav__link"
                        }, {
                          default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                            _createTextVNode(" Typography ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["to"])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_13, [
            _createElementVNode("div", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($data.layoutsIsOpen = !$data.layoutsIsOpen)),
              class: _normalizeClass([{ 'is-open': $data.layoutsIsOpen }, "c-nav__link has-subnav"])
            }, [
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_icon_layouts)
              ]),
              _cache[13] || (_cache[13] = _createElementVNode("div", { class: "c-nav__name" }, "Layouts", -1)),
              _cache[14] || (_cache[14] = _createElementVNode("span", { class: "c-nav__subnav-caret" }, null, -1))
            ], 2),
            _createVNode(_component_transition_expand, null, {
              default: _withCtx(() => [
                ($data.layoutsIsOpen)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_15, [
                      _createElementVNode("li", _hoisted_16, [
                        _createVNode(_component_router_link, {
                          to: { name: $data.RESPONSIVE_BREAKPOINTS_ROUTE_NAME },
                          class: "c-subnav__link"
                        }, {
                          default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                            _createTextVNode(" Responsive Breakpoints ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["to"])
                      ]),
                      _createElementVNode("li", _hoisted_17, [
                        _createVNode(_component_router_link, {
                          to: { name: $data.APP_LAYOUTS_ROUTE_NAME },
                          class: "c-subnav__link"
                        }, {
                          default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                            _createTextVNode(" Application Layouts ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["to"])
                      ]),
                      _createElementVNode("li", _hoisted_18, [
                        _createVNode(_component_router_link, {
                          to: { name: $data.LAYOUT_OBJECTS_ROUTE_NAME },
                          class: "c-subnav__link"
                        }, {
                          default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                            _createTextVNode(" Layout Objects ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["to"])
                      ]),
                      _createElementVNode("li", _hoisted_19, [
                        _createVNode(_component_router_link, {
                          to: { name: $data.FLEXBOX_GRID_ROUTE_NAME },
                          class: "c-subnav__link"
                        }, {
                          default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                            _createTextVNode(" Grid System ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["to"])
                      ]),
                      _createElementVNode("li", _hoisted_20, [
                        _createVNode(_component_router_link, {
                          to: { name: $data.LAYOUT_HELPERS_ROUTE_NAME },
                          class: "c-subnav__link"
                        }, {
                          default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                            _createTextVNode(" Layout Helpers ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["to"])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_21, [
            _createElementVNode("div", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => ($data.formsIsOpen = !$data.formsIsOpen)),
              class: _normalizeClass([{ 'is-open': $data.formsIsOpen }, "c-nav__link has-subnav"])
            }, [
              _createElementVNode("div", _hoisted_22, [
                _createVNode(_component_icon_forms)
              ]),
              _cache[20] || (_cache[20] = _createElementVNode("div", { class: "c-nav__name" }, "Forms", -1)),
              _cache[21] || (_cache[21] = _createElementVNode("span", { class: "c-nav__subnav-caret" }, null, -1))
            ], 2),
            _createVNode(_component_transition_expand, null, {
              default: _withCtx(() => [
                ($data.formsIsOpen)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_23, [
                      _createElementVNode("li", _hoisted_24, [
                        _createVNode(_component_router_link, {
                          to: { name: $data.FORM_GROUP_OBJECT_ROUTE_NAME },
                          class: "c-subnav__link"
                        }, {
                          default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                            _createTextVNode(" Form Group Object ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["to"])
                      ]),
                      _createElementVNode("li", _hoisted_25, [
                        _createVNode(_component_router_link, {
                          to: { name: $data.INPUT_AND_VALIDATION_ROUTE_NAME },
                          class: "c-subnav__link"
                        }, {
                          default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                            _createTextVNode(" Basic Input & Form Messages ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["to"])
                      ]),
                      _createElementVNode("li", _hoisted_26, [
                        _createVNode(_component_router_link, {
                          to: { name: $data.CHECK_AND_RADIO_ROUTE_NAME },
                          class: "c-subnav__link"
                        }, {
                          default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                            _createTextVNode(" Checkbox, Radio & Switch ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["to"])
                      ]),
                      _createElementVNode("li", _hoisted_27, [
                        _createVNode(_component_router_link, {
                          to: { name: $data.SELECT_AND_OPTION_ROUTE_NAME },
                          class: "c-subnav__link"
                        }, {
                          default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                            _createTextVNode(" Select & Option ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["to"])
                      ]),
                      _createElementVNode("li", _hoisted_28, [
                        _createVNode(_component_router_link, {
                          to: { name: $data.INPUT_WITH_ICON_ROUTE_NAME },
                          class: "c-subnav__link"
                        }, {
                          default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                            _createTextVNode(" Input with Icon & File upload ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["to"])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_29, [
            _createElementVNode("div", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => ($data.componentsIsOpen = !$data.componentsIsOpen)),
              class: _normalizeClass([{ 'is-open': $data.componentsIsOpen }, "c-nav__link has-subnav"])
            }, [
              _createElementVNode("div", _hoisted_30, [
                _createVNode(_component_icon_components)
              ]),
              _cache[27] || (_cache[27] = _createElementVNode("div", { class: "c-nav__name" }, "Components", -1)),
              _cache[28] || (_cache[28] = _createElementVNode("span", { class: "c-nav__subnav-caret" }, null, -1))
            ], 2),
            _createVNode(_component_transition_expand, null, {
              default: _withCtx(() => [
                ($data.componentsIsOpen)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_31, [
                      _createElementVNode("li", _hoisted_32, [
                        _createVNode(_component_router_link, {
                          to: { name: $data.BUTTON_COMPONENT_ROUTE_NAME },
                          class: "c-subnav__link"
                        }, {
                          default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                            _createTextVNode(" Button ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["to"])
                      ]),
                      _createElementVNode("li", _hoisted_33, [
                        _createVNode(_component_router_link, {
                          to: { name: $data.BASIC_BOX_COMPONENT_ROUTE_NAME },
                          class: "c-subnav__link"
                        }, {
                          default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                            _createTextVNode(" Box ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["to"])
                      ]),
                      _createElementVNode("li", _hoisted_34, [
                        _createVNode(_component_router_link, {
                          to: { name: $data.USER_HINT_COMPONENT_ROUTE_NAME },
                          class: "c-subnav__link"
                        }, {
                          default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                            _createTextVNode(" Hint ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["to"])
                      ]),
                      _createElementVNode("li", _hoisted_35, [
                        _createVNode(_component_router_link, {
                          to: { name: $data.PILL_BUTTON_COMPONENT_ROUTE_NAME },
                          class: "c-subnav__link"
                        }, {
                          default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
                            _createTextVNode(" Pill ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["to"])
                      ]),
                      _createElementVNode("li", _hoisted_36, [
                        _createVNode(_component_router_link, {
                          to: { name: $data.DATA_TABLE_COMPONENT_ROUTE_NAME },
                          class: "c-subnav__link"
                        }, {
                          default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                            _createTextVNode(" Table ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["to"])
                      ]),
                      _createElementVNode("li", _hoisted_37, [
                        _createVNode(_component_router_link, {
                          to: { name: $data.TABS_COMPONENT_ROUTE_NAME },
                          class: "c-subnav__link"
                        }, {
                          default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
                            _createTextVNode(" Tabs ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["to"])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_38, [
            _createElementVNode("div", {
              onClick: _cache[4] || (_cache[4] = ($event: any) => ($data.utilitiesIsOpen = !$data.utilitiesIsOpen)),
              class: _normalizeClass([{ 'is-open': $data.utilitiesIsOpen }, "c-nav__link has-subnav"])
            }, [
              _createElementVNode("div", _hoisted_39, [
                _createVNode(_component_icon_utilities)
              ]),
              _cache[35] || (_cache[35] = _createElementVNode("div", { class: "c-nav__name" }, "Utility Classes", -1)),
              _cache[36] || (_cache[36] = _createElementVNode("span", { class: "c-nav__subnav-caret" }, null, -1))
            ], 2),
            _createVNode(_component_transition_expand, null, {
              default: _withCtx(() => [
                ($data.utilitiesIsOpen)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_40, [
                      _createElementVNode("li", _hoisted_41, [
                        _createVNode(_component_router_link, {
                          to: { name: $data.HOW_TO_USE_UTILITIES_ROUTE_NAME },
                          class: "c-subnav__link"
                        }, {
                          default: _withCtx(() => [...(_cache[37] || (_cache[37] = [
                            _createTextVNode(" How to use Utility classes ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["to"])
                      ]),
                      _createElementVNode("li", _hoisted_42, [
                        _createVNode(_component_router_link, {
                          to: { name: $data.COLORS_UTILITY_CLASSES_ROUTE_NAME },
                          class: "c-subnav__link"
                        }, {
                          default: _withCtx(() => [...(_cache[38] || (_cache[38] = [
                            _createTextVNode(" Colors ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["to"])
                      ]),
                      _createElementVNode("li", _hoisted_43, [
                        _createVNode(_component_router_link, {
                          to: { name: $data.TYPOGRAPHY_UTILITY_CLASSES_ROUTE_NAME },
                          class: "c-subnav__link"
                        }, {
                          default: _withCtx(() => [...(_cache[39] || (_cache[39] = [
                            _createTextVNode(" Typography ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["to"])
                      ]),
                      _createElementVNode("li", _hoisted_44, [
                        _createVNode(_component_router_link, {
                          to: { name: $data.GAPS_UTILITY_CLASSES_ROUTE_NAME },
                          class: "c-subnav__link"
                        }, {
                          default: _withCtx(() => [...(_cache[40] || (_cache[40] = [
                            _createTextVNode(" Spacings ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["to"])
                      ]),
                      _createElementVNode("li", _hoisted_45, [
                        _createVNode(_component_router_link, {
                          to: { name: $data.LAYOUT_UTILITY_CLASSES_ROUTE_NAME },
                          class: "c-subnav__link"
                        }, {
                          default: _withCtx(() => [...(_cache[41] || (_cache[41] = [
                            _createTextVNode(" Layout Helpers ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["to"])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_46, [
            _createElementVNode("div", {
              onClick: _cache[5] || (_cache[5] = ($event: any) => ($data.devsIsOpen = !$data.devsIsOpen)),
              class: _normalizeClass([{ 'is-open': $data.devsIsOpen }, "c-nav__link has-subnav"])
            }, [
              _createElementVNode("div", _hoisted_47, [
                _createVNode(_component_icon_devs)
              ]),
              _cache[42] || (_cache[42] = _createElementVNode("div", { class: "c-nav__name" }, "For Developers", -1)),
              _cache[43] || (_cache[43] = _createElementVNode("span", { class: "c-nav__subnav-caret" }, null, -1))
            ], 2),
            _createVNode(_component_transition_expand, null, {
              default: _withCtx(() => [
                ($data.devsIsOpen)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_48, [
                      _createElementVNode("li", _hoisted_49, [
                        _createVNode(_component_router_link, {
                          to: { name: $data.CSS_RULES_ROUTE_NAME },
                          class: "c-subnav__link"
                        }, {
                          default: _withCtx(() => [...(_cache[44] || (_cache[44] = [
                            _createTextVNode(" CSS Rules ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["to"])
                      ]),
                      _createElementVNode("li", _hoisted_50, [
                        _createVNode(_component_router_link, {
                          to: { name: $data.HTML_RULES_ROUTE_NAME },
                          class: "c-subnav__link"
                        }, {
                          default: _withCtx(() => [...(_cache[45] || (_cache[45] = [
                            _createTextVNode(" HTML Rules ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["to"])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_51, [
            _createElementVNode("div", {
              onClick: _cache[6] || (_cache[6] = ($event: any) => ($data.hiddenSection = !$data.hiddenSection)),
              class: _normalizeClass([{ 'is-open': $data.hiddenSection }, "c-nav__link has-subnav"])
            }, [...(_cache[46] || (_cache[46] = [
              _createElementVNode("div", { class: "c-nav__icon" }, null, -1),
              _createElementVNode("div", { class: "c-nav__name" }, " ", -1),
              _createElementVNode("span", { class: "c-nav__subnav-caret" }, null, -1)
            ]))], 2),
            _createVNode(_component_transition_expand, null, {
              default: _withCtx(() => [
                ($data.hiddenSection)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_52, [...(_cache[47] || (_cache[47] = [
                      _createElementVNode("li", { class: "c-subnav__item" }, " ", -1)
                    ]))]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ]))
}